// extracted by mini-css-extract-plugin
export default {"flex":"HVBreadcrumbs_module-TOCMW4DR_flex__6B1wO","text":"HVBreadcrumbs_module-TOCMW4DR_text__yLZl1","textActive":"HVBreadcrumbs_module-TOCMW4DR_textActive__Ldtv+"};